App.controller('DownloadCtrl', ['$scope', '$sce', '$state', '$http', function ($scope, $sce, $state, $http) {
    
}]);